// extracted by mini-css-extract-plugin
export default {"register":"RegistrationReminder-module--register--558c2","wave":"RegistrationReminder-module--wave--34441"};